import { render, staticRenderFns } from "./JobDetailBasic.vue?vue&type=template&id=2c2e0f70&"
import script from "./JobDetailBasic.vue?vue&type=script&lang=js&"
export * from "./JobDetailBasic.vue?vue&type=script&lang=js&"
import style0 from "./JobDetailBasic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports